import {gql} from "@irati/utils/gql"

export const adminBusiness = gql`
  fragment adminBusiness on Business {
    uuid
    businessName
    globalAdminRoleId
    globalAdminCount
    isEnabled
    loginPageSsoButtonText
    rootTeamId
    showPasswordLogin
    showSsoLogin
    subdomain
    featureFlags
    metadata {
      createdAt
      createdBy
    }
    contractStartDate
    selfRegistrations
    businessType
    creationMetadata {
      reasonForCreation
    }
    rewardPointsName
  }
`
